export default __webpack_public_path__ + "static/bds-logo-5ccd3326673bbc52da26dc7541a0a3a5.jpg";